import Flickity from "flickity";

class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-carousel]');
        self.carouselElemMobile = self.elem.querySelector('[data-carousel-mobile]');
        self.cards = self.elem.querySelectorAll('.card');
    }

    init() {
        let self = this;

        self.getCarousel();
    }

    getCarousel() {
        let self = this;

        let flktyOptions = {
            contain: true,
            draggable: true,
            wrapAround: true
        };

        const flkty = new Flickity(self.carouselElem, flktyOptions);
        const flktyMobile = new Flickity(self.carouselElemMobile, flktyOptions);
    }
}

export default Carousel;
